import React, { useState } from 'react';
import { Search, User, ShoppingCart, PackageSearch } from 'lucide-react';
import logo from '../assets/logo-eletrovex.webp';
import logoSmall from '../assets/logo-eletrovex-240.webp';
import { Link, useNavigate } from 'react-router-dom';

const Header = ({ cartCount = 0 }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const submitSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (q) {
      navigate(`/busca?q=${encodeURIComponent(q)}`);
      setSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <>
      {/* Top Banner */}
      <div className="bg-gradient-to-r from-blue-700 to-blue-600 text-white py-2 overflow-hidden">
        <div className="animate-scroll whitespace-nowrap">
          <span className="inline-block px-8">🚚 Frete grátis acima de R$ 300</span>
          <span className="inline-block px-8">✓ 10% de Cashback para a próxima compra</span>
          <span className="inline-block px-8">🚚 Frete grátis acima de R$ 300</span>
          <span className="inline-block px-8">✓ 10% de Cashback para a próxima compra</span>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-28">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src={logo}
                srcSet={`${logoSmall} 240w, ${logo} 480w`}
                sizes="(max-width: 768px) 160px, 192px"
                width="480"
                height="240"
                alt="ELETROVEX"
                fetchPriority="high"
                decoding="async"
                className="h-24 w-auto drop-shadow-md transition-transform hover:scale-105"
              />
            </Link>

            {/* Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                INÍCIO
              </Link>
              <Link to="/categoria/exaustores" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                EXAUSTORES
              </Link>
              <Link to="/categoria/kits" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                KITS
              </Link>
              <Link to="/categoria/churrasqueira" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                CHURRASQUEIRA
              </Link>
              <Link to="/categoria/cooktops" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                COOKTOPS
              </Link>
              <Link to="/categoria/pecas" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors">
                PEÇAS
              </Link>
              <Link to="/categoria/grades" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors" data-testid="nav-grades">
                GRADES
              </Link>
              <Link to="/rastreio" className="text-gray-700 hover:text-blue-700 font-semibold transition-colors" data-testid="nav-rastreio">
                RASTREIO
              </Link>
            </nav>

            {/* Right Icons */}
            <div className="flex items-center space-x-4 md:space-x-6">
              {/* Rastreio (mobile) */}
              <Link
                to="/rastreio"
                className="md:hidden text-gray-600 hover:text-blue-700 transition-colors"
                aria-label="Rastrear Pedido"
                title="Rastrear Pedido"
                data-testid="header-rastreio-mobile"
              >
                <PackageSearch size={24} />
              </Link>
              {/* Search */}
              <div className="relative">
                {searchOpen ? (
                  <form onSubmit={submitSearch}>
                    <input
                      type="text"
                      placeholder="O que você procura?"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-64 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:border-blue-600 transition-all"
                      onBlur={() => setTimeout(() => setSearchOpen(false), 200)}
                      autoFocus
                      data-testid="header-search-input"
                    />
                  </form>
                ) : (
                  <button
                    onClick={() => setSearchOpen(true)}
                    className="text-gray-600 hover:text-blue-700 transition-colors"
                    data-testid="header-search-btn"
                    aria-label="Buscar"
                  >
                    <Search size={24} />
                  </button>
                )}
              </div>

              {/* User → Fale Conosco */}
              <Link
                to="/contato"
                className="text-gray-600 hover:text-blue-700 transition-colors"
                aria-label="Fale Conosco"
                title="Fale Conosco"
                data-testid="header-user-contact"
              >
                <User size={24} />
              </Link>

              {/* Cart */}
              <Link
                to="/carrinho"
                className="relative text-gray-600 hover:text-blue-700 transition-colors"
                data-testid="header-cart-link"
              >
                <ShoppingCart size={24} />
                {cartCount > 0 && (
                  <span
                    className="absolute -top-2 -right-2 bg-yellow-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                    data-testid="header-cart-count"
                  >
                    {cartCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </header>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          display: inline-block;
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </>
  );
};

export default Header;
